const DAY_MS = 24 * 60 * 60 * 1000;

// The date the Calendar page derives "which week to load" from (startOfWeek of it),
// given FullCalendar's visible range [start, end).
//
// Week views (5+ days) keep the original "Safe Date": start + 2 days (the Wednesday),
// far enough from either edge that no timezone offset can push it into a neighbouring
// week.
//
// Shorter views (phones: Day, 3 Days) anchor on the range's middle DAY — +2 days from
// a Sunday in Day view would land in the NEXT week. FullCalendar runs with a named
// timeZone and no timezone plugin, so it hands back UTC-coerced dates: their UTC fields
// are the calendar day shown. Read them as such and pin the result to local noon, so
// the device-local startOfWeek sees that same day whatever the device offset (an
// "add 12 hours" midpoint rolled into the next day at UTC+12 and beyond). The page's
// fetch pads the week by a full day each side, which covers a 3-day view straddling
// two weeks.
export function weekAnchorDate(start, end) {
  const spanMs = end - start;
  if (spanMs >= 5 * DAY_MS) {
    const anchor = new Date(start);
    anchor.setDate(anchor.getDate() + 2); // Add 2 days (Wed)
    return anchor;
  }
  const middleDay = Math.floor(Math.round(spanMs / DAY_MS) / 2); // Day → 0, 3 days → 1
  return new Date(start.getUTCFullYear(), start.getUTCMonth(), start.getUTCDate() + middleDay, 12);
}
